import "./app.scss";
import "styles/sharedStyles/statuses.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import Header from "components/Header/index";

import MyProfile from "components/MyProfile/index";
import AllNews from "components/AllNews/index";
import AllVacancies from "components/AllVacancies/index";
import MyCandidates from "components/MyCandidates/index";
import Error from "components/Error/index";
import OneNewsNewPage from "components/AllNews/OneNewsNewPage/index";
import OneVacancyPage from "components/AllVacancies/OneVacancyPage/index";
import { useEffect } from "react";
import AboutUs from "components/AboutUs";

function App() {
  const storageToken = window.localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    !storageToken && navigate("/allvacancies");

    const handleInvalidToken = (e) => {
      if (e.key === "token" && e.oldValue && !e.newValue) {
        navigate("/allvacancies");
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleInvalidToken);

    return function cleanup() {
      window.removeEventListener("storage", handleInvalidToken);
    };
  }, [storageToken]);

  return (
    <div className="app">
      <Header />
      <div className="main">
        <Routes>
          <Route exact path="/aboutus" element={<AboutUs />} />
          <Route exact path="/allnews" element={<AllNews />} />
          <Route exact path="/allnews/:id" element={<OneNewsNewPage />} />
          <Route exact path="/allvacancies" element={<AllVacancies />} />
          <Route exact path="/allvacancies/:id" element={<OneVacancyPage />} />
          <Route exact path="/mycandidates" element={<MyCandidates />} />
          <Route exact path="/myprofile" element={<MyProfile />} />

          <Route exact path="/" element={<Navigate to="/allnews" />} />

          <Route path="*" element={<Error />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
